import { IAppState } from '../context/Context'
import { TCF } from '../../../../cmp/tcf/TCF'
import { GOOGLE_VENDOR_ID } from '../../../constants/gdprVendors'
import { bodyScroll } from '../../../helpers/scroll'
import { AC } from '../../../ac/AC'

export namespace Save {
  export const reducer = (prevState: IAppState): IAppState => {
    AC.setSome(prevState.acceptedAcPartners)
    TCF.consentDoesApply({ displayUi: false })
    TCF.setCookie()
    // We're closing the modal, allow the body to scroll
    bodyScroll(true)
    // Track Google consent and legitimate interest status in NR upon modal close
    const googleConsent: boolean = TCF.tcModel.vendorConsents.has(
      GOOGLE_VENDOR_ID
    )
    const googleLegitimateInterests: boolean = TCF.tcModel.vendorLegitimateInterests.has(
      GOOGLE_VENDOR_ID
    )
    window.$mediavine.newrelic.addPageAction('gdprModal', { googleConsent })
    window.$mediavine.newrelic.addPageAction('gdprModal', {
      googleLegitimateInterests
    })
    return {
      ...prevState,
      view: null
    }
  }
}
